import React from 'react';
import PlaceholderPage from './PlaceholderPage';

const PlateToVINRecord: React.FC = () => {
  return (
    <PlaceholderPage
      title="Plate To VIN Record"
      description="Look up VIN numbers using license plate information"
    />
  );
};

export default PlateToVINRecord;
